import React from 'react';
import { NavLink } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';

const SignedOutLinks = () => {
    return (
        <ul className="navbar-nav mr-auto">
            <li className="nav-item"><NavLink className="nav-link" to={ROUTES.SIGNUP}>Sign Up</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link" to={ROUTES.SIGNIN}>Login</NavLink></li>
        </ul>
    )
};

export default SignedOutLinks;
